import { cn } from '@zealot/ui/lib/utils';
import { Loader2, TriangleAlert } from 'lucide-react';
import type * as React from 'react';
import { Button } from './button';

type InlineErrorProps = {
  message?: React.ReactNode;
  onRetry?: () => void;
  isRetrying?: boolean;
  className?: string;
};

// gloss
const InlineError = ({
  message = 'Something went wrong',
  onRetry,
  isRetrying = false,
  className,
}: InlineErrorProps) => {
  return (
    <div data-slot="inline-error" className={cn('flex items-center gap-2 text-muted-foreground text-sm', className)}>
      <TriangleAlert className="size-4 shrink-0 text-destructive" />
      <span>{message}</span>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} disabled={isRetrying}>
          {isRetrying && <Loader2 className="animate-spin" />}
          Retry
        </Button>
      )}
    </div>
  );
};

export type { InlineErrorProps };
export { InlineError };
